// extracted by mini-css-extract-plugin
export default {"root":"ZwP105","check":"TeHRdB","description":"ZkZ6a7","bold":"Hirv7d"};